module.exports = __webpack_public_path__ + "img/thumb-rodney-off.6e610eab.jpg";